import { IonItemDivider } from "@ionic/react";
import { useSelector } from "react-redux";
import { MessageItem } from "../../../components/Message/MessageItem";
import { selectDocumentHistory } from "../../../store/documentSignerShow/selectors/selectDocumentHIstory";

export const DocumentHistory: React.FC = () => {
  const messages = useSelector(selectDocumentHistory);

  return (
    <section style={{ maxWidth: "900px" }}>
      {Object.entries(messages).map(([key, value]: any) => (
        <article key={key}>
          <IonItemDivider className="ion-margin-bottom">{key}</IonItemDivider>

          {value.map((messageItem: any) => (
            <MessageItem key={messageItem.id} message={messageItem} routerLink={``}></MessageItem>
          ))}
        </article>
      ))}
    </section>
  );
};
